import { useState } from 'react';
import { TabsUI } from '../../Interface';
import ComplaintReportD1 from './ComplaintReportD1';
import ComplaintReportD2 from './ComplaintReportD2';
import ComplaintReportD3 from './ComplaintReportD3';
import ComplaintReportD4 from './ComplaintReportD4';
import ComplaintReportD5 from './ComplaintReportD5';
import ComplaintReportD6 from './ComplaintReportD6';
import ComplaintReportD7 from './ComplaintReportD7';
import ComplaintReportD8 from './ComplaintReportD8';
import { ReportType } from '../../../config/complaintReport';

const ComplaintReportTabs = (props) => {
  const { type } = props;
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'D1 - Csapat összeállítás',
      content: <ComplaintReportD1 {...props} />,
    },
    {
      id: 1,
      name: 'D2 - Probléma leírása',
      content: <ComplaintReportD2 {...props} />,
    },
    {
      id: 2,
      name: 'D3 - Ideiglenes intézkedések',
      content: <ComplaintReportD3 {...props} />,
    },
    {
      id: 3,
      name: 'D4 - Gyökérok elemzés',
      content: <ComplaintReportD4 {...props} />,
    },
    ...(type === ReportType.REPORT8D
      ? [
          {
            id: 4,
            name: 'D5 - Javító intézkedések',
            content: <ComplaintReportD5 {...props} />,
          },
          {
            id: 5,
            name: 'D6 - Megoldások bevezetése',
            content: <ComplaintReportD6 {...props} />,
          },
          {
            id: 6,
            name: 'D7 - Ismétlődés megelőzése',
            content: <ComplaintReportD7 {...props} />,
          },
          {
            id: 7,
            name: 'D8 - Projekt állapota',
            content: <ComplaintReportD8 {...props} />,
          },
        ]
      : []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick} multiRowTabs>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ComplaintReportTabs;
